export default (resp, isEmptyResp) => {
    if (!resp.ok) {
        if (resp.status > 400 && resp.status < 500) {
            if (resp.status === 401) {
                window.location.replace(`${window.location.origin}/login?401`);
            }
            if (resp.status === 403) {
                throw resp;
            }
            return resp.json().then(data => {
                console.warn(data);
                const err = {
                    errorMessage: data.message || data.detail || data.errors[0],
                };
                throw err;
            });
        }
        return resp.json().then(data => {
            console.warn(data);
            if (data) {
                const err = {
                    errorMessage: data.message || data,
                    nextAvailableTimeslot: data.nextAvailableTimeslot || null,
                    nextDateStatus: data.nextDateStatus || null
                };
                throw err;
            } else {
                const err = {
                    errorMessage: `Bad Request - ${resp.status}`
                };
                throw err;
            }
        });
    }

    if (resp.status === 204 || isEmptyResp) {
        return resp;
    }

    return resp.json();
};
